const cityTranslations = {
    "Ramallah": "رام الله",
    "Jerusalem": "القدس",
    "Gaza": "غزة",
    "Nablus": "نابلس",
    "Hebron": "الخليل",
    "Jenin": "جنين",
    "Tulkarm": "طولكرم",
    "Qalqilya": "قلقيلية",
    "Jericho": "أريحا",
    "Bethlehem": "بيت لحم",
    "Haifa": "حيفا",
    "Jaffa": "يافا",
    "Acre": "عكا",
    "Nazareth": "الناصرة",
    "Tel Aviv": "تل أبيب",
    "Beersheba": "بئر السبع"
};

const translateCity = (city) => {
    if (!city) return "";
    return cityTranslations[city] || city;
};

const LocationReducers = (state = [], action) => {
    switch (action.type) {
        case "LOCATION_LOADING":
            return {
                location: null,
                isLoaded: false
            };
        case "LOCATION_INITIAL":
            return {
                location: {
                    ...action.location,
                    country_code: action.location.countryCode ? action.location.countryCode.toLowerCase() : "",
                    Address: translateCity(action.location?.city)
                },
                isLoaded: true
            };
        default:
            return state;
    }
}

export default LocationReducers;